<div id="notify-me-gold"
  class="hmf-mt-xxs hmf-display-flex hmf-flex-nowrap hmf-align-items-center"
  [ngClass]="{'hmf-mx-l': isPanelText}">
  <homefield-icon
    width='63px'
    height='38px'
    name="money-scorecard-gold">
  </homefield-icon>
  <div class="scoreCardGold hmf-body-s hmf-ml-xs">
    <span class="hmf-subheader-bold-s" [ngClass]="{'hmf-display-block': isPanelText}">
      Be the first to know!
    </span>
    ScoreCard Gold members get notified first.
    @if (showDetailsLink) {
      <a hmf-text-link
        [linkURL]="detailsLink"
        altText="Scorecard Gold Details">
        Details
      </a>
    }
  </div>
</div>
